import React from 'react';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleEmailClick = (e) => {
    e.preventDefault();
    window.location.href = 'mailto:' + ['spillebout.charlotte', 'gmail.com'].join('@');
  };

  return (
    <footer className="footer bloc">
      <div className="partie1">
        <ul className="menu">
          <li><NavLink to="/">Accueil</NavLink></li>
          <li><NavLink to="/realisations">Mes réalisations</NavLink></li>
          <li><NavLink to="/mon-parcours">Mon parcours</NavLink></li>
        </ul>

        <div className="reseaux">
          <div className="icon-wrapper">
            <a
              href="https://www.linkedin.com/in/charlotte-spillebout-a38999253/"
              target="_blank"
              rel="noopener noreferrer"
              title="Voir mon profil LinkedIn"
              aria-label="Voir mon profil LinkedIn"
            >
              <img
                className="icon"
                src="/assets/images/logo/logoIN.svg"
                alt="logo linkedin"
              />
              <img
                className="icon hover"
                src="/assets/images/logo/logoINhover.svg"
                alt="logo linkedin hover"
              />
            </a>
          </div>

          <div className="icon-wrapper">
            <a
              href="#"
              onClick={handleEmailClick}
              title="Envoyer un mail"
              aria-label="Envoyer un mail"
            >
              <img
                className="icon"
                src="/assets/images/logo/mail.svg"
                alt="logo mail"
              />
              <img
                className="icon hover"
                src="/assets/images/logo/mailhover.svg"
                alt="logo mail hover"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="partie2"></div>

      <div className="partie3">
        <div className="copyright">
          <p>&copy; {currentYear} Charlotte Spillebout - Tous droits réservés</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
